import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as Actions from './actions';

const HelpIcon = Record({
    video: '',
    title: '',
    description: '',
    articles: List(),
    show: false,
});

const helpIcon = handleActions(
    {
        [Actions.fetchHelp.type]: () => new HelpIcon(),
        [Actions.fetchHelpSuccess.type]: (state, {payload}) => {
            return state.merge({
                video: payload.page.vimeo,
                title: payload.page.title,
                description: payload.page.description,
                articles: List(payload.page.articles),
                show: true,
            });
        },
        [Actions.fetchHelpFailed.type]: state =>
            state.merge({
                video: '',
                title: '',
                description: '',
                articles: List(),
                show: false,
            }),
        [Actions.fetchHelpAborted.type]: state =>
            state.merge({
                video: '',
                title: '',
                description: '',
                articles: List(),
                show: false,
            }),
    },
    new HelpIcon(),
);

export default helpIcon;
